import React from "react";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import Account from "./Account";
import Quizmaster from "./Quizmaster";
import Player from "./Player";
import AboutPage from "./AboutPage";
import CsvQuizEdit from "./csvquizedit";
import QuizAccessManager from "./QuizAccessManager";
import UserAdmin from './UserAdmin';
import PlayerHome from './PlayerHome';
// 1) add this import at the top with your other imports:
import MarketingSite from "./Marketing/MarketingSite";
import Pricing from "./Pricing";

// ADD these imports at the top with your other page imports:
import BillingSuccess from "./pages/BillingSuccess";
import BillingCanceled from "./pages/BillingCanceled";
import QuizmasterLogin from "./QuizmasterLogin";

// NEW: Sign-up page
import Signup from "./pages/Signup";
import ShareQuiz from "./ShareQuiz";
import LibraryViewer from "./LibraryViewer";
import DuplicateQuestionsViewer from "./DuplicateQuestionsViewer";
import BugsFeaturesReleases from "./BugsFeaturesReleases";
import TestQuizRunner from "./pages/TestQuizRunner";
import MarketingManager from "./Marketing/MarketingManager";
import MusicDownloader from "./MusicDownloader";
import PrivacyPolicyPage from "./pages/PrivacyPolicyPage";
import SupportPage from "./pages/SupportPage";

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/login" replace />} />
        <Route path="/play/" element={<PlayerHome />} />
        <Route path="/play/:gameCode" element={<Player />} />
        <Route path="/playerhome" element={<PlayerHome />} />
        <Route path="/host" element={<Quizmaster />} />
        <Route path="/about" element={<AboutPage />} />
        <Route path="/About" element={<AboutPage />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/support" element={<SupportPage />} />
        <Route path="/csvquizedit" element={<CsvQuizEdit />} />
        <Route path="/quizaccess" element={<UserAdmin />} />

        <Route path="/pitch" element={<MarketingSite />} />

        <Route path="/pricing" element={<Pricing />} />

        <Route path="/billing/success" element={<BillingSuccess />} />
        <Route path="/billing/canceled" element={<BillingCanceled />} />

        <Route path="/login" element={<QuizmasterLogin />} />
        <Route path="/signup" element={<Signup />} />
        <Route path="/account" element={<Account />} />
        <Route path="/share" element={<ShareQuiz />} />

        <Route path="/library-viewer" element={<LibraryViewer />} />
        <Route path="/music-downloader" element={<MusicDownloader />} />
        <Route path="/duplicate-questions" element={<DuplicateQuestionsViewer />} />
        <Route path="/bugs-features-releases" element={<BugsFeaturesReleases />} />
        <Route path="/marketing" element={<MarketingManager />} />
        <Route path="/testQuizscript" element={<TestQuizRunner />} />
      </Routes>
    </BrowserRouter>
  );
}
